var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9833 4.5V7.99196L6.23732 9.73794",
    stroke: "#FFBB37",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2738 7.28419C13.8688 7.28224 13.5389 7.60898 13.537 8.01397C13.5354 8.33849 13.5053 8.66093 13.4478 8.97762C13.3755 9.3761 13.6399 9.75777 14.0384 9.83009C14.4368 9.90241 14.8185 9.638 14.8908 9.23952C14.9634 8.83944 15.0016 8.43174 15.0036 8.02101C15.0055 7.61602 14.6788 7.28613 14.2738 7.28419Z",
    fill: "#FFBB37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7828 10.5232C13.4328 10.3195 12.9839 10.4382 12.7802 10.7883C12.6184 11.0665 12.4321 11.3314 12.2226 11.5792C11.9612 11.8886 12 12.3513 12.3094 12.6127C12.6187 12.8741 13.0814 12.8352 13.3428 12.5259C13.6079 12.2122 13.8435 11.8772 14.048 11.5258C14.2516 11.1757 14.1329 10.7268 13.7828 10.5232Z",
    fill: "#FFBB37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85968 13.2174C9.47869 13.3547 9.28117 13.775 9.41852 14.1559C9.55587 14.5369 9.97607 14.7345 10.3571 14.5971C10.5475 14.5285 10.7364 14.4511 10.9233 14.3649C11.1101 14.2787 11.2916 14.1852 11.4674 14.0849C11.8192 13.8843 11.9417 13.4364 11.741 13.0846C11.5404 12.7328 11.0925 12.6103 10.7407 12.811C10.6015 12.8904 10.4575 12.9646 10.3089 13.0331C10.1604 13.1017 10.0105 13.163 9.85968 13.2174Z",
    fill: "#FFBB37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9833 14.2771C4.5119 14.2771 1.69777 11.463 1.69777 7.99159C1.69777 4.52018 4.5119 1.70605 7.9833 1.70605C10.4512 1.70605 12.5869 3.12837 13.6155 5.19802V2.40445",
    stroke: "#FFBB37",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.74cdaf24d26c1613f52dceec257fed49.svg";
export { ForwardRef as ReactComponent };